import { AlertCircle } from "lucide-react";

const inputCls =
    "w-full bg-transparent border-b border-[rgba(201,168,106,0.3)] focus:border-[#C9A86A] outline-none text-[#F3EFE7] text-base py-2.5 px-1 transition-colors duration-300";

function ErrorRow({ message }) {
    return (
        <p className="mt-2 flex items-center gap-2 text-[12px] text-[#C97A6A]">
            <AlertCircle size={12} strokeWidth={1.6} />
            {message}
        </p>
    );
}

export default function AccessFormFields({ form, errors, setField }) {
    return (
        <>
            <div>
                <label
                    htmlFor="pa_name"
                    className="block text-[10.5px] tracking-[0.32em] uppercase text-[#9A958A] mb-3"
                >
                    Full Name
                    <span aria-hidden className="text-[#C9A86A] ml-1">*</span>
                </label>
                <input
                    id="pa_name"
                    type="text"
                    autoComplete="name"
                    value={form.full_name}
                    onChange={(e) => setField("full_name", e.target.value)}
                    className={inputCls}
                    data-testid="private-access-full_name"
                />
                {errors.full_name && <ErrorRow message={errors.full_name} />}
            </div>

            <div>
                <label
                    htmlFor="pa_email"
                    className="block text-[10.5px] tracking-[0.32em] uppercase text-[#9A958A] mb-3"
                >
                    Email
                    <span aria-hidden className="text-[#C9A86A] ml-1">*</span>
                </label>
                <input
                    id="pa_email"
                    type="email"
                    autoComplete="email"
                    value={form.email}
                    onChange={(e) => setField("email", e.target.value)}
                    className={inputCls}
                    data-testid="private-access-email"
                />
                {errors.email && <ErrorRow message={errors.email} />}
            </div>

            <div>
                <label
                    htmlFor="pa_passcode"
                    className="block text-[10.5px] tracking-[0.32em] uppercase text-[#9A958A] mb-3"
                >
                    Passcode
                    <span aria-hidden className="text-[#C9A86A] ml-1">*</span>
                </label>
                <input
                    id="pa_passcode"
                    type="password"
                    autoComplete="off"
                    value={form.passcode}
                    onChange={(e) => setField("passcode", e.target.value)}
                    className={`${inputCls} font-mono tracking-wider`}
                    data-testid="private-access-passcode"
                />
                {errors.passcode && <ErrorRow message={errors.passcode} />}
            </div>
        </>
    );
}
